var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.89 2.485a3.765 3.765 0 0 0-2.8-1.22c-.809 0-1.55.256-2.2.76a4.5 4.5 0 0 0-.89.929 4.498 4.498 0 0 0-.89-.93 3.521 3.521 0 0 0-2.2-.758 3.765 3.765 0 0 0-2.8 1.219C.395 3.26 0 4.323 0 5.473c0 1.184.441 2.268 1.389 3.411.847 1.022 2.065 2.06 3.475 3.262.482.41 1.028.876 1.595 1.372a.821.821 0 0 0 1.082 0c.567-.496 1.113-.961 1.595-1.372 1.41-1.202 2.628-2.24 3.476-3.262C13.559 7.74 14 6.657 14 5.473c0-1.15-.395-2.212-1.11-2.988Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h14v14H0z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.ad672281dda76943a2895ff66c725578.svg";
export { ForwardRef as ReactComponent };